import React, { useEffect, useState } from "react";
import {
  Drawer,
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Checkbox,
  TreeSelect,
  message,
  Spin,
  Row,
  Col,
  Modal,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { getAllBrand } from "../../../../actions/Inventory/brandAction";
import { getAllTag } from "../../../../actions/Inventory/tagAction";
import { getAllCategory } from "../../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../../actions/contactAction";
import { getOnlyWarehouse } from "../../../../actions/warehouseAction";
import { 
  createSingleProduct, 
  checkDuplicateProduct 
} from "../../../../actions/singleProductAction";

const { Option } = Select;
const { confirm } = Modal;

const CreateProduct = ({
  open,
  onClose,
  getAllBrand,
  getAllTag,
  getAllCategory,
  getOnlyWarehouse,
  getAllContactMerchandiser,
  createSingleProduct,
  checkDuplicateProduct,
  brandList,
  tagList,
  Warehouse,
  categoryList,
  supplierList,
  setUpdatelist,
  onSuccess, 
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllBrand();
    getAllTag();
    getAllCategory();
    getOnlyWarehouse();
    getAllContactMerchandiser();
  }, []);

  useEffect(() => {
    const fetchWarehouse = async () => {
      const warehouses = await getOnlyWarehouse();
      if (warehouses.length > 0) {
        form.setFieldsValue({ Warehouse: warehouses[0].id });
      }
    };
    fetchWarehouse();
  }, [getOnlyWarehouse, form]);

  const handleCreateProduct = async (values) => {
    try {
      const res = await createSingleProduct(values);
      
      if (res) { 
        message.success("Product created successfully!");
        form.resetFields();
        
        if (onSuccess) {
          onSuccess();
        }
        
        if (setUpdatelist) {
          setUpdatelist((prev) => !prev);
        }
        
        onClose();
        window.location.reload();
      }
    } catch (error) {
      message.error("Failed to create product. Try again!");
      console.error(error);
      throw error;
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    
    try {
      const duplicateCheck = await checkDuplicateProduct(
        values.title,
        values.Category,
        values.Brand || null,
        values.Tag || []
      );
      
      if (duplicateCheck && duplicateCheck.exists) {
        const selectedBrand = brandList.find(brand => brand.id === values.Brand);
        const selectedCategory = categoryList.find(cat => cat.value === values.Category);
        const selectedTags = tagList.filter(tag => values.Tag && values.Tag.includes(tag.id));
        
        const brandName = selectedBrand ? selectedBrand.name : 'No Brand';
        const categoryName = selectedCategory ? selectedCategory.title : '';
        const tagNames = selectedTags.map(tag => tag.name).join(', ') || 'No Tags';
        
        confirm({
          title: 'Duplicate Product Detected',
          icon: <ExclamationCircleOutlined />,
          width: 600,
          content: (
            <div>
              <p style={{ marginBottom: 16, fontSize: '14px' }}>
                A product with identical details already exists in the system:
              </p>
              <div style={{ 
                backgroundColor: '#fff7e6', 
                padding: 16, 
                borderRadius: 6,
                border: '1px solid #ffd591',
                marginBottom: 16 
              }}>
                <p style={{ margin: '6px 0', fontSize: '13px' }}>
                  <strong>Title:</strong> {duplicateCheck.product.title}
                </p>
                <p style={{ margin: '6px 0', fontSize: '13px' }}>
                  <strong>Category:</strong> {categoryName}
                </p>
                <p style={{ margin: '6px 0', fontSize: '13px' }}>
                  <strong>Brand:</strong> {brandName}
                </p>
                <p style={{ margin: '6px 0', fontSize: '13px' }}>
                  <strong>Tags:</strong> {tagNames}
                </p>
                {duplicateCheck.product.product_code && (
                  <p style={{ margin: '6px 0', fontSize: '13px' }}>
                    <strong>Product Code:</strong> {duplicateCheck.product.product_code}
                  </p>
                )}
              </div>
              <p style={{ marginTop: 16, color: '#ff4d4f', fontSize: '14px', fontWeight: '500' }}>
                Creating a duplicate may cause confusion. Do you want to proceed anyway?
              </p>
            </div>
          ),
          okText: 'Yes, Create Duplicate',
          okType: 'danger',
          cancelText: 'No, Cancel',
          onOk: async () => {
            try {
              await handleCreateProduct(values);
            } catch (error) {
              setLoading(false);
            }
          },
          onCancel() {
            setLoading(false);
          },
        });
      } else {
        // No duplicate 
        await handleCreateProduct(values);
      }
    } catch (error) {
      message.error("Failed to check for duplicates. Please try again!");
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="Create New Product"
      width={780}
      onClose={() => {
        onClose();
        form.resetFields();
      }}
      open={open}
      destroyOnClose
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Spin spinning={loading}>
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="title"
                label="Product Title"
                rules={[{ required: true, message: "Please enter product title" }]}
              >
                <Input placeholder="Enter product name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="Category"
                label="Category"
                rules={[{ required: true, message: "Please select a category" }]}
              >
                <TreeSelect
                  showSearch
                  placeholder="Please select"
                  treeDefaultExpandAll
                  allowClear
                  treeNodeFilterProp="title"
                  treeData={categoryList}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item 
              name="Brand" 
              label="Brand"
              rules={[{ required: true, message: "Please enter product title" }]}

              >
                <Select
                  showSearch
                  placeholder="Select brand"
                  allowClear
                  optionFilterProp="children" 
                  filterOption={(input, option) =>
                    ((option && option.children) ? option.children.toLowerCase() : '')
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    ((optionA && optionA.children) ? optionA.children.toLowerCase() : '')
                      .localeCompare(
                        (optionB && optionB.children) ? optionB.children.toLowerCase() : ''
                      )
                  }
                >
                  {brandList.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item 
              name="Tag" 
              label="Tags"
              rules={[{ required: true, message: "Please enter product title" }]}

              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select tag"
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    ((option && option.children) ? option.children.toLowerCase() : '')
                      .includes(input.toLowerCase())
                  }
                >
                  {tagList.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Warehouse"
                label="Warehouse"
                rules={[{ required: true, message: "Please select a warehouse" }]}
              >
                <Select showSearch placeholder="Select warehouse">
                  {Warehouse.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="stock_alart_amount"
                label="Stock Alert Amount"
                rules={[{ required: false, message: "Enter stock alert amount" }]}
              >
                <InputNumber style={{ width: "100%" }} min={0} placeholder="e.g., 10" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="is_active" valuePropName="checked" initialValue={true}>
                <Checkbox style={{ marginTop: 30 }}>Active Product</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  Create Product
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  brandList: state.brand.brandlist || [],
  tagList: state.tag.taglist || [],
  categoryList: state.category.categorylist || [],
  Warehouse: state.warehouse.warehouselist || [],
  supplierList: state.contacts.contactlistsearchresult || [],
});

export default connect(mapStateToProps, {
  getAllBrand,
  getAllTag,
  getAllCategory,
  getOnlyWarehouse,
  getAllContactMerchandiser,
  createSingleProduct,
  checkDuplicateProduct,
})(CreateProduct);